<ng-container >
  @for (fullStar of filledStars; track fullStar) {
    <span class="ratings"><fa-icon [icon]="faStar"></fa-icon></span>
  }
  @if (hasHalfStar) {
    <span class="ratings"><fa-icon [icon]="faStarHalf"></fa-icon></span>
  }
  @for (empty of emptyStars; track empty) {
    <span class="ratings"><fa-icon [icon]="faStarEmpty"></fa-icon></span>
  }
</ng-container>
